import styled from 'styled-components';
import { TextBlock } from '../text';
import { FontFamilyMedium, FontSize20 } from '../fonts';

export const AccordionHeader = styled.div`
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const AccordionCloseIconContainer = styled.div`
    transition: transform 0.2s ease-in-out;
    transform-origin: center;
    transform: ${props => props.isOpened ? 'rotate(0)' : 'rotate(45deg)'};
    width: 22px;
    height: 22px;
`;

export const AccordionTitle = styled(TextBlock)`
    ${FontFamilyMedium};
    ${FontSize20};
`;

export const ContentContainer = styled.div`
    overflow: hidden;
    position: relative;
    border-radius: 24px;
    box-shadow: 0 4px 20px 0 rgba(81, 129, 186, 0.15);
    padding: 0 20px 0px 20px;
    transition: max-height 0.2s ease-in-out;
`;

export const AccordionCloseClickingArea = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 70px;
    cursor: pointer; 
`;